import { render, staticRenderFns } from "./PrivilegeAgreementTab.vue?vue&type=template&id=a3423c92&scoped=true&"
import script from "./PrivilegeAgreementTab.vue?vue&type=script&lang=js&"
export * from "./PrivilegeAgreementTab.vue?vue&type=script&lang=js&"
import style0 from "./PrivilegeAgreementTab.vue?vue&type=style&index=0&id=a3423c92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3423c92",
  null
  
)

export default component.exports